import api from './api';

export const getBanners = async () => {
  try {
    const response = await api.get('ObterBannersHome');
    return response.data.results;
  } catch (err) {
    console.error('Erro ao obter banners:', err);
    return [];
  }
};
